import axiosInstance from ".";

export const getFooter = () => {
  return axiosInstance.get("/footer");
};

export const addFooter = (data) => {
  return axiosInstance.post("/footer", data);
};

export const updateFooter = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/footer/${id}`, payload);
};
